module.exports = __webpack_public_path__ + "img/pantalla-3-1-10.a55c5069.png";